import React from 'react';
import { StyleSheet } from 'react-native';
import { useMediaQuery } from 'react-responsive';

import { useConsumerStatusSummaryQuery } from 'apollo/queries/autogenerate/hooks';
import { AppleCreditStatus } from 'apollo/queries/autogenerate/schemas';
import BannerAmazon from 'shared/assets/images/banners/banner-mobile-amazon-5-percent@3x.png';
import BannerAppleNonPPFA from 'shared/assets/images/banners/banner-mobile-apple-non-ppfa@3x.png';
import BannerApplePPFA from 'shared/assets/images/banners/banner-mobile-apple-ppfa@3x.png';
import BannerNpay from 'shared/assets/images/banners/banner-mobile-npay@3x.png';
import BannerShopping from 'shared/assets/images/banners/banner-mobile-shopping@3x.png';
import BannerAmazonWeb from 'shared/assets/images/banners/banner-web-amazon-5-percent@3x.png';
import BannerAppleNonPPFAWeb from 'shared/assets/images/banners/banner-web-apple-non-ppfa@3x.png';
import BannerApplePPFAWeb from 'shared/assets/images/banners/banner-web-apple-ppfa@3x.png';
import BannerNpayWeb from 'shared/assets/images/banners/banner-web-npay@3x.png';
import BannerShoppingWeb from 'shared/assets/images/banners/banner-web-shopping@3x.png';
import { isPlusUser } from 'shared/consumer/utils/consumer-types';
import Carousel, {
  Item,
} from 'shared/modules/common/components/molecules/Carousel';
import useIsShoppingEnabled from 'shared/modules/common/hooks/use-is-shopping-enabled';

type Props = {
  onItemPress?: (item: Item) => void;
};

const Banners = (props: Props) => {
  const isBigScreen = useMediaQuery({ minWidth: 768 });
  const shopping = useIsShoppingEnabled();
  const { data: consumerSummaryData } = useConsumerStatusSummaryQuery({
    fetchPolicy: 'cache-only',
  });

  const items: Item[] = [];

  // Banner order: Apple > Amazon > Npay > Shop

  // #1 Apple
  const bannerAppleWeb =
    consumerSummaryData?.appleCreditStatus.status === AppleCreditStatus.APPROVED
      ? BannerApplePPFAWeb
      : BannerAppleNonPPFAWeb;
  const bannerApple =
    consumerSummaryData?.appleCreditStatus.status === AppleCreditStatus.APPROVED
      ? BannerApplePPFA
      : BannerAppleNonPPFA;

  items.push({
    id: 'apple',
    imageUri: isBigScreen ? bannerAppleWeb : bannerApple,
  });

  // #2 Amazon
  items.push({
    id: 'amazon',
    imageUri: isBigScreen ? BannerAmazonWeb : BannerAmazon,
  });

  // #3 NPAY
  if (
    isPlusUser(
      consumerSummaryData?.KYCApplicationStatus.status,
      consumerSummaryData?.houkatsuStatus.status
    )
  ) {
    items.push({
      id: 'npay',
      imageUri: isBigScreen ? BannerNpayWeb : BannerNpay,
    });
  }

  // #4 Shopping
  if (shopping) {
    items.push({
      id: 'shopping',
      imageUri: isBigScreen ? BannerShoppingWeb : BannerShopping,
    });
  }

  return (
    <Carousel
      items={items}
      style={!isBigScreen ? style.carousel : style.carouselBigScreen}
      numColumns={isBigScreen ? 2 : 1}
      onItemPress={props.onItemPress}
      id="banners-carousel"
    />
  );
};

const style = StyleSheet.create({
  carousel: {
    marginHorizontal: -16,
    paddingHorizontal: 16,
    paddingBottom: 5,
  },
  carouselBigScreen: {
    paddingBottom: 5,
  },
});

export default Banners;
